import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ImageComponent } from '@epicuro-next/ataraxia/image';
import { Product } from 'graphql-api/gql-api-interfaces';

import { ProductImageMissingVisualConfig } from '../../types';

@Component({
  selector: 'atx-product-image',
  templateUrl: './product-image.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ProductImageComponent {
  @Input() public product: Product;
  @Input() public imageUrl: string;
  @Input() public failedLoadIconSize: string =
    ImageComponent.defaultFailedLoadIconSize;
  @Input() public maxWidth: number;
  @Input()
  public productImageMissingVisualConfig?: ProductImageMissingVisualConfig;
  @Input() public missingImageUrlSignatures: string[] = [
    'default.jpg',
    'placeholder-image.jpg',
  ];
  @Input() public fallbackImageUrl: string;

  public imageLoaded = false;
  public imageError = false;

  public get showMissingVisual(): boolean {
    if (!this.productImageMissingVisualConfig?.enabled) {
      return false;
    }

    const show =
      this.imageError || this.urlMatchesMissingImageUrlSignature(this.imageUrl);
    return show;
  }

  public onImageLoaded(): void {
    this.imageLoaded = true;
  }

  public onImageError(): void {
    this.imageError = true;
  }

  private urlMatchesMissingImageUrlSignature(url: string): boolean {
    return this.missingImageUrlSignatures.some((signature) =>
      url.includes(signature),
    );
  }
}
